import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PublicoAlvoApi } from '../../../environment/publicos-alvo/apis/publico-alvo.api';

export interface IPopulacaoElegivel {
  total: number | null;
  mes: number | null;
  ano: number | null;
  medindo: boolean;
}

const VAZIA: IPopulacaoElegivel = {
  total: null,
  mes: null,
  ano: null,
  medindo: false,
};

@Injectable({ providedIn: 'root' })
export class PopulacaoElegivelService implements OnDestroy {
  private estado$ = new BehaviorSubject<IPopulacaoElegivel>(VAZIA);
  private falha$ = new Subject<void>();
  private populacaoPorPublicoAlvo: Record<number, number> = {};
  private medicao?: Subscription;

  constructor(private publicoAlvoApi: PublicoAlvoApi) {}

  ngOnDestroy(): void {
    this.medicao?.unsubscribe();
    this.estado$.complete();
    this.falha$.complete();
  }

  observar(): Observable<IPopulacaoElegivel> {
    return this.estado$.asObservable();
  }

  observarFalhas(): Observable<void> {
    return this.falha$.asObservable();
  }

  get atual(): IPopulacaoElegivel {
    return this.estado$.value;
  }

  registrarPopulacoes(mapa: Record<number, number>): void {
    this.populacaoPorPublicoAlvo = mapa;
  }

  resetar(): void {
    this.medicao?.unsubscribe();
    this.populacaoPorPublicoAlvo = {};
    this.estado$.next(VAZIA);
  }

  definirDoLoad(total: number | null, mes: number | null, ano: number | null): void {
    this.estado$.next({ total, mes, ano, medindo: false });
  }

  medir(ids: number[]): void {
    this.medicao?.unsubscribe();

    if (ids.length === 0) {
      this.estado$.next(VAZIA);
      return;
    }

    this.estado$.next({
      ...this.estado$.value,
      total: this.somarLocal(ids),
      medindo: true,
    });

    this.medicao = this.publicoAlvoApi
      .fetchPopulacao(ids)
      .pipe(
        finalize(() =>
          this.estado$.next({ ...this.estado$.value, medindo: false })
        )
      )
      .subscribe({
        next: (resposta) =>
          this.estado$.next({
            total: resposta.total,
            mes: resposta.mes,
            ano: resposta.ano,
            medindo: false,
          }),
        error: () => {
          this.estado$.next({ ...this.estado$.value, medindo: false });
          this.falha$.next();
        },
      });
  }

  private somarLocal(ids: number[]): number {
    return ids.reduce(
      (total, id) => total + (this.populacaoPorPublicoAlvo[id] ?? 0),
      0
    );
  }
}
